import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_6 = { class: "col p-0" }
const _hoisted_7 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_8 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_9 = { class: "col p-0" }
const _hoisted_10 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_11 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_14 = { class: "col p-0" }
const _hoisted_15 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "form-group mb-2 col" }
const _hoisted_18 = { class: "col-auto p-0 text-end" }
const _hoisted_19 = { class: "row mt-2" }
const _hoisted_20 = { class: "form-group mb-2 col-sm-12" }
const _hoisted_21 = { class: "col p-0" }
const _hoisted_22 = { class: "me-3" }
const _hoisted_23 = ["id", "checked", "disabled", "onChange"]
const _hoisted_24 = ["for"]
const _hoisted_25 = { class: "row mt-2" }
const _hoisted_26 = { class: "form-group mb-2 col-sm-6" }
const _hoisted_27 = { class: "col p-0" }
const _hoisted_28 = ["value", "id"]
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "col-sm-6 text-end" }
const _hoisted_31 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "card card-body mb-0" }
const _hoisted_34 = {
  key: 0,
  class: "text-center text-muted p-4"
}
const _hoisted_35 = {
  key: 1,
  class: "text-center text-muted p-4"
}
const _hoisted_36 = { key: 2 }
const _hoisted_37 = {
  key: 3,
  class: "overflow-auto"
}
const _hoisted_38 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_39 = { class: "bg-light" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "text-muted" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_AdminMultiselect = _resolveComponent("AdminMultiselect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.requestDTO.fromDate,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.from_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_7)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.requestDTO.toDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.to_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_10)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_AdminMultiselect, {
                    multiple: true,
                    modelValue: _ctx.adminsFilter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adminsFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Multiselect, {
                    id: "support-activity-directions",
                    class: "multiselect-sm",
                    modelValue: _ctx.requestDTO.directions,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.directions) = $event)),
                    options: Object.values(_ctx.Direction),
                    "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.type')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Multiselect, {
                    id: "support-activity-currencies",
                    class: "multiselect-sm multiselect-capitalize",
                    modelValue: _ctx.requestDTO.currencies,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.currencies) = $event)),
                    options: _ctx.store.getters['currencyMethods/currencies'],
                    "custom-label": (opt) => opt,
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.currency')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.applyFilters()), ["prevent"])),
                    class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.clearFilters()), ["prevent"])),
                    class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans('statistic.supportActivity.results_label')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.SupportActivityResult), (result) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-check form-check-inline",
                      key: result
                    }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: `support-activity-result-${result}`,
                        checked: _ctx.requestDTO.results.includes(result),
                        disabled: _ctx.isOnlyPickedResult(result),
                        onChange: ($event: any) => (_ctx.toggleResult(result))
                      }, null, 40, _hoisted_23),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `support-activity-result-${result}`
                      }, _toDisplayString(_ctx.helper.trans(`statistic.supportActivity.filter_result.${result}`)), 9, _hoisted_24)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['chart', 'table'], (mode) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: mode }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.viewMode) = $event)),
                        value: mode,
                        class: "btn-check",
                        name: "support-activity-view",
                        id: `support-activity-view-${mode}`,
                        autocomplete: "off"
                      }, null, 8, _hoisted_28), [
                        [_vModelRadio, _ctx.viewMode]
                      ]),
                      _createElementVNode("label", {
                        class: "btn btn-sm btn-outline-dark me-2",
                        for: `support-activity-view-${mode}`
                      }, _toDisplayString(_ctx.helper.trans(`statistic.supportActivity.view.${mode}`)), 9, _hoisted_29)
                    ], 64))
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.downloadReport()), ["prevent"])),
                  class: "btn btn-outline-primary btn-sm rounded-pill text-capitalize-first"
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa-solid fa-download" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.download_report')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            (!_ctx.isLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.helper.trans('statistic.supportActivity.prompt')), 1))
              : (_ctx.isEmpty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.helper.trans('statistic.supportActivity.empty')), 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans('statistic.supportActivity.retention_hint')), 1)
                  ]))
                : (_ctx.viewMode === 'chart')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_component_Bar, {
                        "chart-options": _ctx.chartOptions,
                        "chart-data": _ctx.chartData
                      }, null, 8, ["chart-options", "chart-data"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("table", _hoisted_38, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                              return (_openBlock(), _createElementBlock("th", {
                                key: column.field,
                                class: "text-capitalize-first",
                                role: "button",
                                onClick: ($event: any) => (_ctx.sortBy(column.field))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.helper.trans(column.title)) + " ", 1),
                                (_ctx.sortField === column.field)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: _normalizeClass(["fa-solid", _ctx.sortDesc ? 'fa-caret-down' : 'fa-caret-up'])
                                    }, null, 2))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_40))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedItems, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `${item.bucket}-${item.adminId}-${item.result}-${item.direction}-${item.currency}-${index}`
                            }, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.bucket, _ctx.bucketFormat)), 1),
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(item.adminName) + " ", 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("small", _hoisted_41, _toDisplayString(item.adminEmail), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`user_roles.${item.adminRole}`)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`statistic.supportActivity.result.${item.result}`)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`direction.${item.direction}`)), 1),
                              _createElementVNode("td", null, _toDisplayString(item.currency), 1),
                              _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.numberFormatter.formatNumber(item.count)), 1),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(item.takerSum ?? '0'), 2)) + " " + _toDisplayString(item.currency), 1),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(item.makerSum ?? '0'), 2)) + " " + _toDisplayString(item.makerCurrency), 1),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.helper.formatDuration(item.reactionSecondsAvg)) + " / " + _toDisplayString(_ctx.helper.formatDuration(item.reactionSecondsMin)) + " / " + _toDisplayString(_ctx.helper.formatDuration(item.reactionSecondsMax)), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}